import { render, staticRenderFns } from "./ProductDetailsPopup.vue?vue&type=template&id=42c7984b&scoped=true"
import script from "./ProductDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsPopup.vue?vue&type=style&index=0&id=42c7984b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c7984b",
  null
  
)

export default component.exports